export default "__VITE_ASSET__BM5lVSr___"